/**
 * @flow
 * @relayHash eca69a8958e797ee6b0da44e24add347
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type trackSearch_viewer$ref = any;
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type SearchSortField = ('Date' | 'Featured' | 'Price' | 'Score' | '%future added value');
export type SearchSortOrderDirection = ('Asc' | 'Desc' | '%future added value');
export type TrackSimilarityFeature = ('Default' | '%future added value');
export type trackSearchQueryVariables = {|
  offset?: ?number,
  count?: ?number,
  query?: ?string,
  filters?: ?{
    term_filters?: ?$ReadOnlyArray<?string>,
    not_term_filters?: ?$ReadOnlyArray<?string>,
    collection_slug?: ?string,
    artist_slug?: ?string,
    budget?: ?{
      minimum?: ?number,
      maximum?: ?number,
    },
    duration?: ?{
      minimum?: ?number,
      maximum?: ?number,
    },
    tempo?: ?{
      minimum?: ?number,
      maximum?: ?number,
    },
    similarity?: ?{
      track_id: string,
      feature: TrackSimilarityFeature,
    },
  },
  taxonomy_query?: ?{
    query: string,
    taxonomy_id: number,
  },
  license_params?: ?$ReadOnlyArray<?{
    spot_count?: ?number,
    term?: ?number,
    medium: number,
    contextual_param?: ?$ReadOnlyArray<?number>,
    contextual_param_type: string,
  }>,
  sort?: ?{
    field: SearchSortField,
    order: SearchSortOrderDirection,
  },
  currency?: ?Currency,
|};
export type trackSearchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: trackSearch_viewer$ref,
  |},
|};
*/


/*
query trackSearchQuery(
  $offset: Int
  $count: Int
  $query: String
  $filters: TrackSearchFilters
  $taxonomy_query: TaxonomyQuery
  $license_params: [LicenseUsageParamsInput]
  $sort: SearchSortOrder
  $currency: Currency
) {
  viewer {
    ...trackSearch_viewer
    id
  }
}

fragment trackSearch_viewer on Viewer {
  ...signUpCta_viewer
  trackSearch(first: $count, offset: $offset, query: $query, filters: $filters, taxonomy_query: $taxonomy_query, license_params: $license_params, sort: $sort, currency: $currency) {
    edges {
      node {
        id
        internal_id
        price
        base_price
        title
        added_to_cart
        slug
        duration
        score
        boosted_score
        stems_available
        customizable
        matched_exclusions
        tempos {
          id
          name
          value
        }
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          bio
          bandcamp
          facebook
          instagram
          itunes
          soundcloud
          spotify
          twitter
          wiki
          youtube
          homebase
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms(first: 100) {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
        collections {
          edges {
            node {
              id
              description
              name
              slug
              category {
                id
                name
              }
              assets {
                id
                version
                type
                file_format
                path
                metadata
              }
            }
            id
          }
        }
        association_id
        selected_version
        __typename
      }
      id
      cursor
    }
    total
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...trackSearchTaxonomies_viewer
}

fragment signUpCta_viewer on Viewer {
  home_page {
    sign_up_cta_images
  }
}

fragment trackSearchTaxonomies_viewer on Viewer {
  selected_currency
  trackSearch(first: $count, offset: $offset, query: $query, filters: $filters, taxonomy_query: $taxonomy_query, license_params: $license_params, sort: $sort, currency: $currency) {
    edges {
      node {
        id
        __typename
      }
      id
      cursor
    }
    taxonomy_cardinalities
    term_cardinalities
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "filters",
    "type": "TrackSearchFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "taxonomy_query",
    "type": "TaxonomyQuery",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "license_params",
    "type": "[LicenseUsageParamsInput]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "SearchSortOrder",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "currency",
    "type": "Currency",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "trackSearchQuery",
  "id": null,
  "text": "query trackSearchQuery(\n  $offset: Int\n  $count: Int\n  $query: String\n  $filters: TrackSearchFilters\n  $taxonomy_query: TaxonomyQuery\n  $license_params: [LicenseUsageParamsInput]\n  $sort: SearchSortOrder\n  $currency: Currency\n) {\n  viewer {\n    ...trackSearch_viewer\n    id\n  }\n}\n\nfragment trackSearch_viewer on Viewer {\n  ...signUpCta_viewer\n  trackSearch(first: $count, offset: $offset, query: $query, filters: $filters, taxonomy_query: $taxonomy_query, license_params: $license_params, sort: $sort, currency: $currency) {\n    edges {\n      node {\n        id\n        internal_id\n        price\n        base_price\n        title\n        added_to_cart\n        slug\n        duration\n        score\n        boosted_score\n        stems_available\n        customizable\n        matched_exclusions\n        tempos {\n          id\n          name\n          value\n        }\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          bio\n          bandcamp\n          facebook\n          instagram\n          itunes\n          soundcloud\n          spotify\n          twitter\n          wiki\n          youtube\n          homebase\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms(first: 100) {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n        collections {\n          edges {\n            node {\n              id\n              description\n              name\n              slug\n              category {\n                id\n                name\n              }\n              assets {\n                id\n                version\n                type\n                file_format\n                path\n                metadata\n              }\n            }\n            id\n          }\n        }\n        association_id\n        selected_version\n        __typename\n      }\n      id\n      cursor\n    }\n    total\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...trackSearchTaxonomies_viewer\n}\n\nfragment signUpCta_viewer on Viewer {\n  home_page {\n    sign_up_cta_images\n  }\n}\n\nfragment trackSearchTaxonomies_viewer on Viewer {\n  selected_currency\n  trackSearch(first: $count, offset: $offset, query: $query, filters: $filters, taxonomy_query: $taxonomy_query, license_params: $license_params, sort: $sort, currency: $currency) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      id\n      cursor\n    }\n    taxonomy_cardinalities\n    term_cardinalities\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "trackSearchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "trackSearch_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "trackSearchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "home_page",
            "storageKey": null,
            "args": null,
            "concreteType": "HomePageContent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "sign_up_cta_images",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "trackSearch",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "currency",
                "variableName": "currency",
                "type": "Currency"
              },
              {
                "kind": "Variable",
                "name": "filters",
                "variableName": "filters",
                "type": "TrackSearchFilters"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "license_params",
                "variableName": "license_params",
                "type": "[LicenseUsageParamsInput]"
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "query",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "sort",
                "variableName": "sort",
                "type": "SearchSortOrder"
              },
              {
                "kind": "Variable",
                "name": "taxonomy_query",
                "variableName": "taxonomy_query",
                "type": "TaxonomyQuery"
              }
            ],
            "concreteType": "TrackSearchResultConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TrackSearchResultEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TrackSearchResult",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "stems_available",
                        "args": null,
                        "storageKey": null
                      },
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "price",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "base_price",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "added_to_cart",
                        "args": null,
                        "storageKey": null
                      },
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "duration",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "score",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "boosted_score",
                        "args": null,
                        "storageKey": null
                      },
                      v3,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "customizable",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "matched_exclusions",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tempos",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Tempo",
                        "plural": true,
                        "selections": [
                          v1,
                          v4,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "value",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      v5,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "artist",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Artist",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "itunes",
                            "args": null,
                            "storageKey": null
                          },
                          v1,
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "bio",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "bandcamp",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "facebook",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "instagram",
                            "args": null,
                            "storageKey": null
                          },
                          v4,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "soundcloud",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "spotify",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "twitter",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "wiki",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "youtube",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "homebase",
                            "args": null,
                            "storageKey": null
                          },
                          v5
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "terms",
                        "storageKey": "terms(first:100)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 100,
                            "type": "Int"
                          }
                        ],
                        "concreteType": "TaxonomyTermConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TaxonomyTermEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TaxonomyTerm",
                                "plural": false,
                                "selections": [
                                  v1,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "is_highlighted",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v4,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "parent_id",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "taxonomy",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Taxonomy",
                                    "plural": false,
                                    "selections": [
                                      v1,
                                      v3,
                                      v4
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "collections",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CollectionTrackConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CollectionTrackEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Collection",
                                "plural": false,
                                "selections": [
                                  v1,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v4,
                                  v2,
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "category",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CollectionCategory",
                                    "plural": false,
                                    "selections": [
                                      v1,
                                      v4
                                    ]
                                  },
                                  v5
                                ]
                              },
                              v1
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "association_id",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "selected_version",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "taxonomy_cardinalities",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "term_cardinalities",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "trackSearch",
            "args": [
              {
                "kind": "Variable",
                "name": "currency",
                "variableName": "currency",
                "type": "Currency"
              },
              {
                "kind": "Variable",
                "name": "filters",
                "variableName": "filters",
                "type": "TrackSearchFilters"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "license_params",
                "variableName": "license_params",
                "type": "[LicenseUsageParamsInput]"
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "query",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "sort",
                "variableName": "sort",
                "type": "SearchSortOrder"
              },
              {
                "kind": "Variable",
                "name": "taxonomy_query",
                "variableName": "taxonomy_query",
                "type": "TaxonomyQuery"
              }
            ],
            "handle": "connection",
            "key": "trackSearch_trackSearch",
            "filters": [
              "offset",
              "query",
              "filters",
              "taxonomy_query",
              "license_params",
              "sort",
              "currency"
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_currency",
            "args": null,
            "storageKey": null
          },
          v1
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'f5653da549fcebe72877bd10d4ddef41';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/trackSearchQuery.graphql.js